import React, { useState } from "react";
import { Link } from "react-router-dom";
import { FaCheck } from "react-icons/fa";

function StartPage() {
  // Gestion des étapes (ici 3 étapes)
  const [step, setStep] = useState(1);

  // formData avec tableaux pour permettre des choix multiples
  const [formData, setFormData] = useState({
    businessSize: [],
    reason: [],
  });

  const handleNextStep = () => {
    setStep((prev) => prev + 1);
  };

  const handlePreviousStep = () => {
    setStep((prev) => prev - 1);
  };

  // Gestion du changement pour les checkbox
  const handleCheckboxChange = (e) => {
    const { name, value, checked } = e.target;
    setFormData((prev) => {
      const currentSelections = prev[name] || [];
      if (checked) {
        // Ajoute la valeur si elle n'est pas déjà présente
        if (!currentSelections.includes(value)) {
          return { ...prev, [name]: [...currentSelections, value] };
        }
      } else {
        // Retire la valeur
        return { ...prev, [name]: currentSelections.filter((item) => item !== value) };
      }
      return prev;
    });
  };

  // Rendu des étapes du formulaire
  const renderStep = () => {
    switch (step) {
      case 1:
        return (
          <div>
            <h2 className="text-2xl md:text-3xl font-bold mb-6">
              Parlez-nous un peu de vous
            </h2>
            <p className="text-gray-600 mb-4">
              Afin de mieux vous accompagner, nous souhaitons mieux comprendre votre profil et vos attentes.
            </p>
            {/* Choix multiples via checkbox */}
            <div className="space-y-3">
              <label className="flex items-center bg-white border border-gray-300 rounded-md p-3 cursor-pointer">
                <input
                  type="checkbox"
                  name="businessSize"
                  value="Je suis marchand de biens"
                  checked={formData.businessSize.includes("Je suis marchand de biens")}
                  onChange={handleCheckboxChange}
                  className="mr-2"
                />
                <span>Je suis marchand de biens</span>
              </label>
              <label className="flex items-center bg-white border border-gray-300 rounded-md p-3 cursor-pointer">
                <input
                  type="checkbox"
                  name="businessSize"
                  value="Je suis investisseur locatif"
                  checked={formData.businessSize.includes("Je suis investisseur locatif")}
                  onChange={handleCheckboxChange}
                  className="mr-2"
                />
                <span>Je suis investisseur locatif</span>
              </label>
              <label className="flex items-center bg-white border border-gray-300 rounded-md p-3 cursor-pointer">
                <input
                  type="checkbox"
                  name="businessSize"
                  value="Je suis agent immobilier"
                  checked={formData.businessSize.includes("Je suis agent immobilier")}
                  onChange={handleCheckboxChange}
                  className="mr-2"
                />
                <span>Je suis agent immobilier</span>
              </label>
            </div>
          </div>
        );
      case 2:
        return (
          <div>
            <h2 className="text-2xl md:text-3xl font-bold mb-6">
              Quels sont vos principaux besoins ?
            </h2>
            <p className="text-gray-600 mb-4">
              Sélectionnez les raisons pour lesquelles vous souhaitez utiliser notre solution.
            </p>
            <div className="space-y-3">
              <label className="flex items-center bg-white border border-gray-300 rounded-md p-3 cursor-pointer">
                <input
                  type="checkbox"
                  name="reason"
                  value="Analyser un secteur"
                  checked={formData.reason.includes("Analyser un secteur")}
                  onChange={handleCheckboxChange}
                  className="mr-2"
                />
                <span>Analyser un secteur</span>
              </label>
              <label className="flex items-center bg-white border border-gray-300 rounded-md p-3 cursor-pointer">
                <input
                  type="checkbox"
                  name="reason"
                  value="Estimer les prix actuels et futurs"
                  checked={formData.reason.includes("Estimer les prix actuels et futurs")}
                  onChange={handleCheckboxChange}
                  className="mr-2"
                />
                <span>Estimer les prix actuels et futurs</span>
              </label>
              <label className="flex items-center bg-white border border-gray-300 rounded-md p-3 cursor-pointer">
                <input
                  type="checkbox"
                  name="reason"
                  value="Détecter des opportunités"
                  checked={formData.reason.includes("Détecter des opportunités")}
                  onChange={handleCheckboxChange}
                  className="mr-2"
                />
                <span>Détecter des opportunités</span>
              </label>
              <label className="flex items-center bg-white border border-gray-300 rounded-md p-3 cursor-pointer">
                <input
                  type="checkbox"
                  name="reason"
                  value="Réaliser des business plan pour vos opérations"
                  checked={formData.reason.includes("Réaliser des business plan pour vos opérations")}
                  onChange={handleCheckboxChange}
                  className="mr-2"
                />
                <span>Réaliser des business plan pour vos opérations</span>
              </label>
              <label className="flex items-center bg-white border border-gray-300 rounded-md p-3 cursor-pointer">
                <input
                  type="checkbox"
                  name="reason"
                  value="Suivre et piloter mes projets"
                  checked={formData.reason.includes("Suivre et piloter mes projets")}
                  onChange={handleCheckboxChange}
                  className="mr-2"
                />
                <span>Suivre et piloter mes projets</span>
              </label>
              <label className="flex items-center bg-white border border-gray-300 rounded-md p-3 cursor-pointer">
                <input
                  type="checkbox"
                  name="reason"
                  value="Structurer mes processus opérationnels"
                  checked={formData.reason.includes("Structurer mes processus opérationnels")}
                  onChange={handleCheckboxChange}
                  className="mr-2"
                />
                <span>Structurer mes processus opérationnels</span>
              </label>
              <label className="flex items-center bg-white border border-gray-300 rounded-md p-3 cursor-pointer">
                <input
                  type="checkbox"
                  name="reason"
                  value="Contrôler et maitriser mes risques opérationnels"
                  checked={formData.reason.includes("Contrôler et maitriser mes risques opérationnels")}
                  onChange={handleCheckboxChange}
                  className="mr-2"
                />
                <span>Contrôler et maitriser mes risques opérationnels</span>
              </label>
            </div>
          </div>
        );
      case 3:
        return (
          <div className="text-center">
            <FaCheck className="text-green-500 text-5xl mx-auto mb-4" />
            <h2 className="text-2xl md:text-3xl font-bold mb-2">
              Merci pour vos réponses !
            </h2>
            <p className="text-gray-700 mb-4">
              Nous sommes prêts à configurer votre espace SELERY.
            </p>
            {/* Changement ici : redirection vers SignupPage (/signup) */}
            <Link
              to="/signup"
              className="inline-block bg-[#00675A] text-white py-3 px-6 rounded-md text-base font-semibold hover:bg-[#00584e] transition-colors"
            >
              Créer mon compte
            </Link>
          </div>
        );
      default:
        return null;
    }
  };

  return (
    <div className="flex flex-col md:flex-row min-h-screen bg-[#FAF7F1] text-[#333]">
      {/* Colonne gauche : formulaire */}
      <div className="md:w-1/2 p-6 md:p-12 flex flex-col justify-center">
        <div className="max-w-lg mx-auto">
          {renderStep()}

          {/* Boutons de navigation (en dessous du formulaire) */}
          <div className="mt-6 flex items-center justify-between">
            {step > 1 && step < 3 && (
              <button
                onClick={handlePreviousStep}
                className="text-[#00675A] underline hover:text-[#004A42]"
              >
                Précédent
              </button>
            )}
            {step < 3 && (
              <button
                onClick={handleNextStep}
                className="bg-[#00675A] text-white py-2 px-4 rounded hover:bg-[#00584e] transition-colors ml-auto"
              >
                Continuer
              </button>
            )}
          </div>
        </div>
      </div>

      {/* Colonne droite : image/visuel */}
      <div className="md:w-1/2 bg-white relative flex items-center justify-center p-8">
        {/* Exemple d'image sur la droite */}
        <div className="max-w-md">
          <img
            src="https://via.placeholder.com/500x400?text=Visual+Preview"
            alt="Mockup"
            className="w-full h-auto"
          />
          <div className="mt-4 text-gray-600 text-sm">
            Gérez vos activités et simplifiez votre comptabilité.
          </div>
        </div>
      </div>
    </div>
  );
}

export default StartPage;